export class PrinterEndpoint {
    uploadFile(): string {
      return "/api/upload";
    }

    autoPrint(id: string): string {
        return `/api/print/${id}`
    }
  }
  